export default "__VITE_ASSET__xplmoDuF__"